/**
 * One labelled fact in a record: a `<dl>` row whose dt/dd pair lines up on
 * the grid the page gives it. Mono marks identifiers; `pre` keeps line
 * breaks in long prose.
 */
export function Fact({
  label,
  value,
  mono,
  pre,
}: {
  label: string
  value: string | null
  mono?: boolean
  pre?: boolean
}) {
  return (
    <div className="contents">
      {/* A phone puts the label over its value; wider screens set them side by side. */}
      <dt className="mt-2 text-caption text-muted-foreground first:mt-0 sm:mt-0 sm:text-ui">{label}</dt>
      <dd
        className={[
          'wf-selectable text-foreground',
          mono ? 'font-mono text-[13px]' : '',
          pre ? 'whitespace-pre-line' : '',
        ].join(' ')}
      >
        {value ?? '—'}
      </dd>
    </div>
  )
}
